/**
 * @prop --width: Width of dialog
 * @prop --padding-top: Padding top of dialog
 * @prop --padding-bottom: Padding bottom of dialog
 * @prop --padding-left: Padding left of dialog
 * @prop --padding-right: Padding right of dialog
 * @prop --backdrop-opacity: Opacity of dialog backdrop
 * @prop --backdrop-background-color: Opacity of dialog background color
 *
 * @prop --stzh-dialog-backdrop-opacity: **Global**: Opacity of backdrops
 * @prop --stzh-dialog-backdrop-background-color: **Global**: Background color of backdrops
 */

:host {
  @include spaceCurve('--padding-top', 'large');
  @include spaceCurve('--padding-bottom', 'large');
  @include spaceCurve('--padding-left', 'medium');
  @include spaceCurve('--padding-right', 'medium');
  --width: 100%;
  --backdrop-opacity: #{$dialogBackdropOpacity};
  --backdrop-background-color: #{$dialogBackdropBackgroundColor};

  @include mq($from: small) {
    --width: 536px;
  }

  @include mq($from: medium) {
    --width: 610px; // 786 before
  }

  @include mq($from: large) {
    --width: 866px; // 832 before
  }

  @include mq($from: ultra) {
    --width: 888px;
  }

  &[size="small"] {
    @include mq($from: small) {
      --width: 395px;
    }

    @include mq($from: medium) {
      --width: 460px;
    }

    @include mq($from: large) {
      --width: 512px;
    }
  }
}

.stzh-dialog {
  z-index: $zIndexDialog;
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: stretch;
  justify-content: stretch;

  &__content {
    z-index: 2;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-grow: 1;
    overflow: auto;
  }

  &__dialog {
    position: relative;
    display: flex;
    flex-direction: column;
    margin: auto;
    border: none;
    background-color: $colorWhite;
    width: auto;
    min-width: var(--width);
    max-width: 100%;
    box-shadow: $boxShadowOverlay;
    height: 100vh;
    max-height: 100vh;
    overflow: hidden;
    outline: none;

    &--fit-content {
      width: fit-content;
    }

    @include mq($from: small) {
      height: auto;
    }
  }

  &__backdrop {
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    text-align: center;
    background-color: var(--backdrop-background-color);
    opacity: var(--backdrop-opacity);
  }

  &__heading {
    @include spaceCurve('padding-bottom', 'regular');
    padding-top: var(--padding-top);
    padding-left: var(--padding-left);
    padding-right: var(--padding-right);
  }

  &__dialog-content {
    padding-left: var(--padding-left);
    padding-right: var(--padding-right);
    @include spaceCurve('padding-top', 'medium');
    @include spaceCurve('padding-bottom', 'medium');
    overflow: auto;
    flex-grow: 1;
  }

  &__actions {
    &:not(:empty) {
      padding: space('medium') var(--padding-right) var(--padding-bottom) var(--padding-left);
    }
  }

  &__close-button {
    position: absolute;
    top: space('xsmall');
    right: space('xsmall');

    @include mq($from: medium) {
      top: space('large');
      right: space('large');
    }
  }

  &--is-open {
    display: flex;
  }
}
